  (() => {
    if (customElements.get('cart-ubigeo')) return;
    const STORE_KEY = 'cero_ubigeo';
    let dataPromise;
    const loadData = (src) => (dataPromise ||= fetch(src).then((r) => r.json()));
    const saved = () => {
      try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
    };

    class CartUbigeo extends HTMLElement {
      connectedCallback() {
        if (!this.wired) {
          this.wired = true;
          // Delegated listeners survive when the cart re-renders the inner markup.
          this.addEventListener('change', (e) => {
            const level = e.target?.dataset?.level;
            if (!level) return;
            this.refs();
            if (level === 'dep') this.onDep();
            if (level === 'prov') this.onProv();
            this.save();
          });
          const ensure = () => this.init();
          this.addEventListener('focusin', ensure);
          this.addEventListener('pointerdown', ensure, true);
          this.observer = new MutationObserver(() => {
            clearTimeout(this.timer);
            this.timer = setTimeout(ensure, 50);
          });
          this.observer.observe(this, { childList: true, subtree: true });
          document.addEventListener('shopify:cart:lines-update', (e) => {
            const later = () => setTimeout(ensure, 50);
            if (e.promise?.then) e.promise.then(later, later); else setTimeout(ensure, 800);
          });
        }
        this.observer.observe(this, { childList: true, subtree: true });
        this.init();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      refs() {
        this.selects = {
          dep: this.querySelector('[data-level="dep"]'),
          prov: this.querySelector('[data-level="prov"]'),
          dist: this.querySelector('[data-level="dist"]'),
        };
        this.error = this.querySelector('.cart-ubigeo__error');
      }

      init() {
        loadData(this.dataset.src).then((data) => {
          this.data = data;
          this.refs();
          if (!this.selects.dep || this.selects.dep.options.length > 1) return;
          this.filling = true;
          this.fill(this.selects.dep, data.map((d) => d[0]));
          const s = saved();
          if (s.dep) { this.selects.dep.value = s.dep; this.onDep(); }
          if (s.prov) { this.selects.prov.value = s.prov; this.onProv(); }
          if (s.dist) this.selects.dist.value = s.dist;
          this.filling = false;
        });
      }

      fill(select, names) {
        select.length = 1;
        names.forEach((n) => select.add(new Option(n.trim(), n.trim())));
        select.disabled = names.length === 0;
      }

      dep() { return this.data?.find((d) => d[0].trim() === this.selects.dep.value); }
      prov() { return this.dep()?.[2].find((p) => p[0].trim() === this.selects.prov.value); }

      onDep() {
        const d = this.dep();
        this.fill(this.selects.prov, d ? d[2].map((p) => p[0]) : []);
        this.fill(this.selects.dist, []);
      }

      onProv() {
        const p = this.prov();
        this.fill(this.selects.dist, p ? p[1] : []);
      }

      save() {
        this.error.hidden = true;
        localStorage.setItem(STORE_KEY, JSON.stringify({
          dep: this.selects.dep.value, prov: this.selects.prov.value, dist: this.selects.dist.value,
        }));
      }

      value() {
        this.refs();
        const d = this.dep();
        const p = this.prov();
        const dist = this.selects.dist.value;
        if (!d || !p || !dist) return null;
        return { dep: d[0].trim(), prov: p[0].trim(), dist, code: p[2] || d[1] };
      }

      validate() {
        const v = this.value();
        if (!v) {
          this.error.hidden = false;
          const empty = Object.values(this.selects).find((s) => !s.value && !s.disabled) || this.selects.dep;
          empty.focus();
        }
        return v;
      }
    }
    customElements.define('cart-ubigeo', CartUbigeo);

    const goToCheckout = async (v, form) => {
      const attrs = { Departamento: v.dep, Provincia: v.prov, Distrito: v.dist };
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        const hasCustom = cart.items.some((i) =>
          i.selling_plan_allocation ||
          Object.keys(i.properties || {}).some((k) => !k.startsWith('_'))
        );
        if (hasCustom || !cart.items.length) throw new Error('fallback');

        const qty = {};
        cart.items.forEach((i) => { qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
        const params = new URLSearchParams();
        params.set('checkout[shipping_address][country]', 'PE');
        params.set('checkout[shipping_address][province]', v.code);
        params.set('checkout[shipping_address][city]', v.dist);
        Object.entries({ ...(cart.attributes || {}), ...attrs }).forEach(([k, val]) => params.set(`attributes[${k}]`, val));
        if (cart.note) params.set('note', cart.note);
        const codes = (cart.discount_codes || []).filter((c) => c.applicable).map((c) => c.code);
        if (codes.length) params.set('discount', codes.join(','));
        const items = Object.entries(qty).map(([id, q]) => `${id}:${q}`).join(',');
        window.location.href = `/cart/${items}?${params.toString()}`;
      } catch (e) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs }),
        }).catch(() => {});
        window.location.href = '/checkout';
      }
    };

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      const ubigeo = submitter.closest('.cart__ctas')?.querySelector('cart-ubigeo');
      if (!ubigeo) return;
      event.preventDefault();
      const v = ubigeo.validate();
      if (!v) return;
      submitter.setAttribute('aria-busy', 'true');
      goToCheckout(v, event.target);
    }, true);
  })();
